import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const styles = css`
  .pills-button-container {
    margin-top: 30px;
  }
  .pills-button-body {
    min-height: 418px;
  }
  .carousel-link {
    color: ${colors.black.shade10};
    text-decoration: none;
    border-bottom: 1px solid ${colors.black.shade10};
  }
`;

export { styles };
